module.exports = __webpack_public_path__ + "static/media/plane.cb274176.svg";